import { Col, Row, Tag } from 'antd';
import moment from 'moment';
import { FC } from 'react';

type Props = {
  title: string;
  editItem?: any;
};
const PageDetailTitle: FC<Props> = (props: Props) => {
  const { editItem, title } = props;
  return (
    <Row className="page-detail__title">
      <Col span={24}> {title} </Col>
      {!!editItem && (
        <Col span={24} style={{ whiteSpace: 'normal' }}>
          {[
            editItem?.creator !== undefined && (
              <Tag key="page-detail-title-6">
                {`Created by: ${editItem?.creator.name}`}
                {}
              </Tag>
            ),

            editItem?.published !== undefined && (
              <Tag key="page-detail-title-1" color={editItem?.published ? 'green' : 'orange'}>
                {`${editItem?.published ? 'Published' : 'Unpublished'}`}
              </Tag>
            ),

            editItem?.defaultShowroom !== undefined && (
              <Tag key="page-detail-title-2" color={editItem?.defaultShowroom ? 'blue' : 'orange'}>
                {`${editItem?.defaultShowroom ? 'Default' : 'Not Default'}`}
              </Tag>
            ),

            editItem?.lastModifiedDate !== undefined && (
              <Tag key="page-detail-title-5">
                {`Last modify: ${moment(editItem?.lastModifiedDate).format(
                  'DD/MM/YYYY, HH:mm:ss'
                )}`}
                {}
              </Tag>
            ),
          ]}
        </Col>
      )}
    </Row>
  );
};

export default PageDetailTitle;
